import React, { Component } from "react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import Table from "../../components/common/table";
import Like from "../../components/common/like";
import Delete from "../../components/common/delete";
import DueDate from "../../components/common/duedate";

class TicketsTable extends Component {
  columns = [
    // {
    //   path: "id",
    //   label: "#",
    //   content: ticket => <Link to={`/tickets/${ticket.id}`}>{ticket.id}</Link>
    // },
    {
      key: "duedate",
      content: ticket => (
        <DueDate duedate={ticket.duedate} />
      )
    },
    {
      path: "ticketid",
      label: "Ticket ID",
      content: ticket => (
        <Link
          to={{
            pathname: `/tickets/${ticket.id}`,
            state: {
              filters: {
                searchQuery: this.props.searchQuery,
                sortColumn: this.props.sortColumn
              }
            }
          }}
        >
          {ticket.ticketid}
        </Link>
      )
    },
    { path: "subject", label: "Subject" },
    { path: "priority", label: "Priority" },
    { path: "status", label: "Status" },
    // { 
    //   path: "customer", 
    //   label: "Customer",
    //   content: ticket => <Link to={`/customers/${ticket.customerid}`}>{ticket.customerid}</Link>
    // },
    { path: "createdAt", label: "Created" },
    // { path: "duedate", label: "Due" },
  ];

  likeColumn = {
    key: "like",
    content: ticket => (
      <Like liked={ticket.liked} onClick={() => this.props.onLike(ticket)} />
    )
  }  

  deleteColumn = {
    key: "delete",
    content: ticket => (
      <Delete onClick={() => this.props.onDelete(ticket)} />
    )
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.role && user.role === "Manager") this.columns.push(this.likeColumn);
    if (user && user.role && user.role === "Administrator") this.columns.push(this.deleteColumn);
  }

  render() {
    const { tickets, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        data={tickets}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default TicketsTable;
